// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-brands-brand-item-text-item-bwgmm{color:#111;text-decoration:none}.components-brands-brand-item-text-item-bwgmm:hover{color:var(--color-primary-hover)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": "components-brands-brand-item-text-item-bwgmm"
};
module.exports = ___CSS_LOADER_EXPORT___;
